import { __extends } from "tslib";
import { namespacedClassnames } from '../../common/namespace-classes';
import { PlaybackRate } from './playback-rate';
import * as React from 'react';
import { SimpleAudioPlayer } from '../simple-audio-player';
import { ActionsMenuButton } from '../actions-menu-button';
import { FloaterMenu, MenuItem } from '../floater-menu/floater-menu';
import { Tooltip } from '../../primitives';
var AudioPlayer = /** @class */ (function (_super) {
    __extends(AudioPlayer, _super);
    function AudioPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            playbackRate: 1,
            playerDisabled: true
        };
        _this.onSelectPlaybackRate = function (rate) {
            _this.setState({ playbackRate: rate });
        };
        _this.updatePlayerDisabledState = function (disabled) {
            var playerDisabled = _this.props.disabled ? true : disabled;
            _this.setState({ playerDisabled: playerDisabled });
        };
        _this.onDownloadRecording = function () {
            window.open(_this.props.audioUrl, '_blank');
        };
        return _this;
    }
    AudioPlayer.prototype.render = function () {
        var props = this.props;
        var key = 'audio-player';
        var disabled = this.state.playerDisabled;
        var classNames = namespacedClassnames(key, { disabled: disabled });
        var downloadText = props.t ? props.t('common.download') : 'Download';
        var deleteRecordingText = props.t ? props.t('common.delete-recording') : 'Delete recording';
        var text = this.props.t ? this.props.t('common.playback-speed') : 'Playback speed';
        return (React.createElement("div", { className: classNames },
            React.createElement(SimpleAudioPlayer, { updateDisabled: this.updatePlayerDisabledState, audioUrl: props.audioUrl, playbackRate: this.state.playbackRate, onPlay: props.onPlay, onPause: props.onPause, disabled: props.disabled, audioFileAnnotations: props.audioFileAnnotations, renderAnnotationTooltip: props.audioFileAnnotations && props.renderAnnotationTooltip, onAnnotationPlayed: props.audioFileAnnotations && props.onAnnotationPlayed }),
            React.createElement(Tooltip, { body: text, direction: 'top', relativeToBody: true },
                React.createElement(PlaybackRate, { onSelect: this.onSelectPlaybackRate, currentRate: this.state.playbackRate })),
            React.createElement("div", { className: 'menu-actions' },
                React.createElement(ActionsMenuButton, { horizontal: true },
                    React.createElement(FloaterMenu, { className: 'action-menu' },
                        React.createElement(MenuItem, { disabled: props.disabled, onSelect: this.onDownloadRecording }, downloadText),
                        React.createElement(MenuItem, { type: 'danger', value: 'delete', disabled: props.isDeleteDisabled || !props.onDelete, onSelect: props.onDelete }, deleteRecordingText))))));
    };
    return AudioPlayer;
}(React.Component));
export { AudioPlayer };
//# sourceMappingURL=audio-player.comp.js.map